module.exports = {
          srcSet: __webpack_public_path__ + "89a7d49ac12084f29863850ca616ba79-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "89a7d49ac12084f29863850ca616ba79-180.png",width: 180,height: 46}],
          src: __webpack_public_path__ + "89a7d49ac12084f29863850ca616ba79-180.png",
          toString:function(){return __webpack_public_path__ + "89a7d49ac12084f29863850ca616ba79-180.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAc0lEQVR4nAXBsQkCQRRF0dn3h1mQxQbsxA4EwdAWFAQDQ8HIcBETsYCNzd+PbMS7tXhOaeRyMWffyKHibeBV4EE/l4ovjVzXOaMIf4Ufwp8O3zo8Cj+F7x2ehN+BpxL42pNjxUfhs/A+8E74IHwKvBF+/QG89DtO/Q6T6wAAAABJRU5ErkJggg==",
          width: 180,
          height: 46
        }